import React from 'react';

const Suggest = (props) => {

  const handleMouseOver = () => props.onMouseOver(props.index);
  const onMouseDown = () => props.onMouseDown(props.value);

  return <div onMouseOver={ handleMouseOver }
              onMouseDown={ onMouseDown }
              className={ 'cabinet-autocomplete-suggestions__item' + (props.active === props.index ? ' active' : '') }
              title={ gettext('Выбрать предложенный вариант') }>
    { props.value }
  </div>
};

export default Suggest;